import PermissionQuickActionButton from './PermissionQuickActionButton';

export default PermissionQuickActionButton;
